import type { StateCardTitleProps } from "./types";

export function StateCardTitle({ children }: StateCardTitleProps) {
  return (
    <h3 className="text-center text-sm font-semibold text-primary">
      {children}
    </h3>
  );
}
